import Swiper from 'swiper/swiper-bundle';

// Swiper slider
new Swiper( '.js-testimonial-slider', {
	spaceBetween: 30,
	loop: true,

	// Navigation arrows
	navigation: {
		nextEl: '.testimonial-next',
		prevEl: '.testimonial-prev',
	},

	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
} );
